<div
  class="group h-full flex flex-col justify-between relative bg-proffeo-surface border border-proffeo-border rounded-xl hover:border-proffeo-surface-off hover:shadow-md transition-all duration-200 overflow-hidden"
>
  <proffeo-file-item-thumbnail
    (click)="preview.emit(file().id)"
    [file]="file()"
    [isAvatar]="isAvatar()"
    class="cursor-pointer w-full h-25"
  />

  <div
    [matMenuTriggerFor]="contextMenu"
    class="flex items-center justify-between pl-2 py-2 cursor-pointer"
  >
    <p
      [matTooltip]="displayLabel()"
      class="flex-1 min-w-0 text-proffeo-text text-sm line-clamp-1 group-hover:text-proffeo-accent-600 transition-colors"
    >
      {{ displayLabel() }}
    </p>
    <mat-icon
      fontIcon="more_vert"
      class="icon-md"
    />
  </div>

  <mat-menu
    #contextMenu="matMenu"
    xPosition="before"
    class="w-44"
  >
    <div
      (click)="$event.stopPropagation()"
      class="flex flex-col gap-3 p-2 w-44"
    >
      <proffeo-file-description
        (descriptionChange)="onDescriptionChange($event)"
        [description]="$safeNavigationMigration(file()?.description)"
      />

      <div class="flex items-center gap-2 px-1">
        <proffeo-avatar
          [user]="$safeNavigationMigration(file()?.createdBy())"
          [size]="avatarSize"
        ></proffeo-avatar>
        <span class="text-sm text-proffeo-muted">
          {{ $safeNavigationMigration(file()?.createdAt) | proffeoDate }}
        </span>
      </div>
    </div>

    <proffeo-file-item-actions
      (preview)="preview.emit(file().id)"
      (delete)="delete.emit(file().id)"
      (download)="download.emit(file().id)"
      (setAsAvatar)="setAsAvatar.emit(file().id)"
      [file]="file()"
      [canSetAsAvatar]="canSetAsAvatar()"
      [isAvatar]="isAvatar()"
    />
  </mat-menu>
</div>
